import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const HardResetConfirmationModal = ({ isOpen, onCloseClick, onResetClick }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.RotateCw size={60} className="text-dark" />
          <div className="fs-4 pt-2">Are you sure?</div>
          <div className="fs-6 pt-2 text-center">
            Before you perform a hard reset, make sure all agents are in the idle stage, not in a
            call or in any other stage.
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button onClick={onResetClick} className="px-5 bg-primary border-primary">
          Reset
        </Button>
      </ModalFooter>
    </Modal>
  );
};

HardResetConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onResetClick: PropTypes.func
};

export default HardResetConfirmationModal;
